import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Slider from 'rc-slider';
import numeral from 'numeral';
import { Integer, DecimalRounded, parseIntUtil } from '../../../utils/NumeralParts';

const MINIMUM_SLIDER_AMOUNT = 50000;
const SLIDER_STEP = 10000;

export default class CustomizeLoanAmount extends React.Component {
  constructor(props) {
    super(props)
    const { loanAmount } = props;
    const loanAmountValue = numeral(loanAmount).value();
    this.state = {
      loanAmountValue
    }
  }

  static defaultProps = {}

  static propTypes = {
    /** Loan amount to be customized */
    loanAmount: PropTypes.number.isRequired,
  }

  static isCustomizable = (amount) => {
    return amount > MINIMUM_SLIDER_AMOUNT
  }

  get fcPaymentId() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    return params.fc_payment_id;
  }

  onChangeSlider = (value) => {
    const { loanAmount } = this.props;
    const loanAmountCeiling = parseIntUtil(loanAmount);
    const valueCeiling = Math.ceil(value);
    const isMax = loanAmountCeiling === valueCeiling;
    let loanAmountValue = value;  
    if (isMax) { loanAmountValue = loanAmount; }
    this.setState({ loanAmountValue }, () => {
      if (typeof this.props.onChangeLoanAmount !== 'function') { return }
      this.props.onChangeLoanAmount(loanAmountValue, { changed: !isMax });
    });
  }

  renderSlider = () => {
    const { loanAmount } = this.props;
    const { loanAmountValue } = this.state;
    if (!this.constructor.isCustomizable(loanAmount)) { return null }
    if (this.fcPaymentId) { return null }
    const format = "0,0";
    const marks = {
      [parseIntUtil(MINIMUM_SLIDER_AMOUNT)]: (
        <span className="-secondary _marginTop--large _marginLeft--xxlarge _fontSize--medium">
          {numeral(MINIMUM_SLIDER_AMOUNT).format(format)}
        </span>
      ),
      [parseIntUtil(loanAmount)]: (
        <span className="-secondary _marginTop--large _marginRight--xxlarge _fontSize--medium">
          {Integer(loanAmount)}
        </span>
      )
    }
    return (
      <div className='_marginLeft--xsmall _marginRight--xsmall _marginBottom--xxlarge'
        data-testid="loan-amount-slider">
        <Slider
          className="ds-slider"
          defaultValue={loanAmountValue}
          marks={marks}
          max={loanAmount}
          min={MINIMUM_SLIDER_AMOUNT}
          step={SLIDER_STEP}
          onChange={this.onChangeSlider}
          dotStyle={{ display: 'none' }}
          activeDotStyle={{ display: 'none' }}
        />
      </div>
    )
  }

  render() {
    const { loanAmountValue } = this.state;
    return (
      <Fragment>
        <div className='_displayFlex _alignItems-center _marginLeft--xsmall _marginTop--normal'>
          <span className='-primary _marginRight--large _marginBottom--small emphasize'>₱</span>
          <h2 className='headline -primary _fontSize--xxlarge'
            data-testid='loan-amount-value'
          >
            {Integer(loanAmountValue)}
          </h2>
          <span className='-primary _alignSelf-center emphasize _marginLeft--xxsmall'
            data-testid='loan-amount-decimal'
          >
            {`${DecimalRounded({ number: loanAmountValue })}`}
          </span>
        </div>
        {this.renderSlider()}
      </Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/features/loans/components/CustomizeLoanAmount.js